import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from 'bringg-web/recipes';
import { TRANSLATION_DOMAINS } from '../../../consts';

const { EXCEPTIONS_LIST: domain } = TRANSLATION_DOMAINS;

interface Props {
	alertId: string;
}

const CompanyCell = ({ alertId }: Props) => {
	const { t } = useTranslation();
	const { companiesStore, alertsStore } = useStores();

	const text: string = useMemo(() => {
		const alert = alertsStore.get(alertId);
		const company = companiesStore.get(alert?.company_id);

		return company ? company.name : t(`${domain}.NO_COMPANY`);
	}, [alertId, alertsStore.all, companiesStore.companies]);

	return <span title={text}>{text}</span>;
};

export default observer(CompanyCell);
